import { render } from "./AdminNews.vue?vue&type=template&id=2674fd2b&scoped=true"
import script from "./AdminNews.vue?vue&type=script&lang=js"
export * from "./AdminNews.vue?vue&type=script&lang=js"

import "./AdminNews.vue?vue&type=style&index=0&id=2674fd2b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2674fd2b"]])

export default __exports__